module.exports = __webpack_public_path__ + "img/hotelFamily-5.ad208377.jpg";